module.exports = __webpack_public_path__ + "static/media/adams1.c16b2984.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/adams/images/adams1.jpg
// module id = 19
// module chunks = 0